import { render, staticRenderFns } from "./CategoryAndValue.vue?vue&type=template&id=529abac6"
import script from "./CategoryAndValue.vue?vue&type=script&lang=js"
export * from "./CategoryAndValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports